// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./Info", "./InfoSolid", "./Search", "./ResetZoom", "./FitToWidth", "./Ellipsis", "./MoreVertical", "./Download", "./Upload", "./Edit", "./Plus", "./Minus", "./Trash", "./ChevronRight", "./ChevronUp", "./ChevronDown", "./ChevronLeft", "./Copy", "./Duplicate", "./Automation", "./Play", "./Pause", "./Scale", "./Form", "./Message", "./Contract", "./Files", "./Profile", "./Building", "./InvoicePaid", "./EditSolid", "./Archive", "./Unarchive", "./Settings", "./Link", "./Close", "./Smile", "./Attachment", "./Share", "./Reply", "./Calendar", "./At", "./List", "./NumberedList", "./UnorderedList", "./Checklist", "./Tasks", "./Filter", "./Templates", "./Star", "./Email", "./EmailUnread", "./EmailRead", "./Authentication", "./Unlock", "./H1", "./H2", "./H3", "./Text", "./Bold", "./Italicize", "./Underline", "./Strikethrough", "./Menu", "./Inbox", "./Home", "./Notification", "./Billing", "./Dollar", "./Helpdesk", "./AppSetup", "./Gift", "./Location", "./Number", "./MobileNumber", "./Airtable", "./QuickBook", "./Bank", "./Puzzle", "./Code", "./ArrowUpSolid", "./ArrowDownSolid", "./ArrowLeft", "./ArrowRight", "./ArrowNE", "./Dash", "./Compose", "./MassFileShare", "./Warning", "./WarningSolid", "./Failed", "./FailedSolid", "./Check", "./Success", "./SuccessSolid", "./New", "./ToDo", "./InProgress", "./Book", "./Send", "./Dot", "./SquareSolid", "./Eye", "./EyeHidden", "./Invoice", "./Comment", "./Invite", "./Spinner", "./Repeat", "./Web", "./Time", "./GraphBarSolid", "./Sidebar", "./SidebarFilled", "./Export", "./File", "./MP4", "./SVG", "./MOV", "./MP3", "./CSV", "./Excel", "./PNG", "./PDF", "./JPG", "./Doc", "./ZIP", "./Movie", "./GIF"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./Info"), require("./InfoSolid"), require("./Search"), require("./ResetZoom"), require("./FitToWidth"), require("./Ellipsis"), require("./MoreVertical"), require("./Download"), require("./Upload"), require("./Edit"), require("./Plus"), require("./Minus"), require("./Trash"), require("./ChevronRight"), require("./ChevronUp"), require("./ChevronDown"), require("./ChevronLeft"), require("./Copy"), require("./Duplicate"), require("./Automation"), require("./Play"), require("./Pause"), require("./Scale"), require("./Form"), require("./Message"), require("./Contract"), require("./Files"), require("./Profile"), require("./Building"), require("./InvoicePaid"), require("./EditSolid"), require("./Archive"), require("./Unarchive"), require("./Settings"), require("./Link"), require("./Close"), require("./Smile"), require("./Attachment"), require("./Share"), require("./Reply"), require("./Calendar"), require("./At"), require("./List"), require("./NumberedList"), require("./UnorderedList"), require("./Checklist"), require("./Tasks"), require("./Filter"), require("./Templates"), require("./Star"), require("./Email"), require("./EmailUnread"), require("./EmailRead"), require("./Authentication"), require("./Unlock"), require("./H1"), require("./H2"), require("./H3"), require("./Text"), require("./Bold"), require("./Italicize"), require("./Underline"), require("./Strikethrough"), require("./Menu"), require("./Inbox"), require("./Home"), require("./Notification"), require("./Billing"), require("./Dollar"), require("./Helpdesk"), require("./AppSetup"), require("./Gift"), require("./Location"), require("./Number"), require("./MobileNumber"), require("./Airtable"), require("./QuickBook"), require("./Bank"), require("./Puzzle"), require("./Code"), require("./ArrowUpSolid"), require("./ArrowDownSolid"), require("./ArrowLeft"), require("./ArrowRight"), require("./ArrowNE"), require("./Dash"), require("./Compose"), require("./MassFileShare"), require("./Warning"), require("./WarningSolid"), require("./Failed"), require("./FailedSolid"), require("./Check"), require("./Success"), require("./SuccessSolid"), require("./New"), require("./ToDo"), require("./InProgress"), require("./Book"), require("./Send"), require("./Dot"), require("./SquareSolid"), require("./Eye"), require("./EyeHidden"), require("./Invoice"), require("./Comment"), require("./Invite"), require("./Spinner"), require("./Repeat"), require("./Web"), require("./Time"), require("./GraphBarSolid"), require("./Sidebar"), require("./SidebarFilled"), require("./Export"), require("./File"), require("./MP4"), require("./SVG"), require("./MOV"), require("./MP3"), require("./CSV"), require("./Excel"), require("./PNG"), require("./PDF"), require("./JPG"), require("./Doc"), require("./ZIP"), require("./Movie"), require("./GIF"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Info, global.InfoSolid, global.Search, global.ResetZoom, global.FitToWidth, global.Ellipsis, global.MoreVertical, global.Download, global.Upload, global.Edit, global.Plus, global.Minus, global.Trash, global.ChevronRight, global.ChevronUp, global.ChevronDown, global.ChevronLeft, global.Copy, global.Duplicate, global.Automation, global.Play, global.Pause, global.Scale, global.Form, global.Message, global.Contract, global.Files, global.Profile, global.Building, global.InvoicePaid, global.EditSolid, global.Archive, global.Unarchive, global.Settings, global.Link, global.Close, global.Smile, global.Attachment, global.Share, global.Reply, global.Calendar, global.At, global.List, global.NumberedList, global.UnorderedList, global.Checklist, global.Tasks, global.Filter, global.Templates, global.Star, global.Email, global.EmailUnread, global.EmailRead, global.Authentication, global.Unlock, global.H1, global.H2, global.H3, global.Text, global.Bold, global.Italicize, global.Underline, global.Strikethrough, global.Menu, global.Inbox, global.Home, global.Notification, global.Billing, global.Dollar, global.Helpdesk, global.AppSetup, global.Gift, global.Location, global.Number, global.MobileNumber, global.Airtable, global.QuickBook, global.Bank, global.Puzzle, global.Code, global.ArrowUpSolid, global.ArrowDownSolid, global.ArrowLeft, global.ArrowRight, global.ArrowNE, global.Dash, global.Compose, global.MassFileShare, global.Warning, global.WarningSolid, global.Failed, global.FailedSolid, global.Check, global.Success, global.SuccessSolid, global.New, global.ToDo, global.InProgress, global.Book, global.Send, global.Dot, global.SquareSolid, global.Eye, global.EyeHidden, global.Invoice, global.Comment, global.Invite, global.Spinner, global.Repeat, global.Web, global.Time, global.GraphBarSolid, global.Sidebar, global.SidebarFilled, global.Export, global.File, global.MP4, global.SVG, global.MOV, global.MP3, global.CSV, global.Excel, global.PNG, global.PDF, global.JPG, global.Doc, global.ZIP, global.Movie, global.GIF);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _Info, _InfoSolid, _Search, _ResetZoom, _FitToWidth, _Ellipsis, _MoreVertical, _Download, _Upload, _Edit, _Plus, _Minus, _Trash, _ChevronRight, _ChevronUp, _ChevronDown, _ChevronLeft, _Copy, _Duplicate, _Automation, _Play, _Pause, _Scale, _Form, _Message, _Contract, _Files, _Profile, _Building, _InvoicePaid, _EditSolid, _Archive, _Unarchive, _Settings, _Link, _Close, _Smile, _Attachment, _Share, _Reply, _Calendar, _At, _List, _NumberedList, _UnorderedList, _Checklist, _Tasks, _Filter, _Templates, _Star, _Email, _EmailUnread, _EmailRead, _Authentication, _Unlock, _H, _H2, _H3, _Text, _Bold, _Italicize, _Underline, _Strikethrough, _Menu, _Inbox, _Home, _Notification, _Billing, _Dollar, _Helpdesk, _AppSetup, _Gift, _Location, _Number, _MobileNumber, _Airtable, _QuickBook, _Bank, _Puzzle, _Code, _ArrowUpSolid, _ArrowDownSolid, _ArrowLeft, _ArrowRight, _ArrowNE, _Dash, _Compose, _MassFileShare, _Warning, _WarningSolid, _Failed, _FailedSolid, _Check, _Success, _SuccessSolid, _New, _ToDo, _InProgress, _Book, _Send, _Dot, _SquareSolid, _Eye, _EyeHidden, _Invoice, _Comment, _Invite, _Spinner, _Repeat, _Web, _Time, _GraphBarSolid, _Sidebar, _SidebarFilled, _Export, _File, _MP, _SVG, _MOV, _MP2, _CSV, _Excel, _PNG, _PDF, _JPG, _Doc, _ZIP, _Movie, _GIF) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_Info).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Info[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Info[key];
      }
    });
  });
  Object.keys(_InfoSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _InfoSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _InfoSolid[key];
      }
    });
  });
  Object.keys(_Search).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Search[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Search[key];
      }
    });
  });
  Object.keys(_ResetZoom).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ResetZoom[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ResetZoom[key];
      }
    });
  });
  Object.keys(_FitToWidth).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _FitToWidth[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _FitToWidth[key];
      }
    });
  });
  Object.keys(_Ellipsis).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Ellipsis[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Ellipsis[key];
      }
    });
  });
  Object.keys(_MoreVertical).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MoreVertical[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MoreVertical[key];
      }
    });
  });
  Object.keys(_Download).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Download[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Download[key];
      }
    });
  });
  Object.keys(_Upload).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Upload[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Upload[key];
      }
    });
  });
  Object.keys(_Edit).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Edit[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Edit[key];
      }
    });
  });
  Object.keys(_Plus).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Plus[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Plus[key];
      }
    });
  });
  Object.keys(_Minus).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Minus[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Minus[key];
      }
    });
  });
  Object.keys(_Trash).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Trash[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Trash[key];
      }
    });
  });
  Object.keys(_ChevronRight).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ChevronRight[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ChevronRight[key];
      }
    });
  });
  Object.keys(_ChevronUp).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ChevronUp[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ChevronUp[key];
      }
    });
  });
  Object.keys(_ChevronDown).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ChevronDown[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ChevronDown[key];
      }
    });
  });
  Object.keys(_ChevronLeft).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ChevronLeft[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ChevronLeft[key];
      }
    });
  });
  Object.keys(_Copy).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Copy[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Copy[key];
      }
    });
  });
  Object.keys(_Duplicate).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Duplicate[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Duplicate[key];
      }
    });
  });
  Object.keys(_Automation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Automation[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Automation[key];
      }
    });
  });
  Object.keys(_Play).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Play[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Play[key];
      }
    });
  });
  Object.keys(_Pause).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Pause[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Pause[key];
      }
    });
  });
  Object.keys(_Scale).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Scale[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Scale[key];
      }
    });
  });
  Object.keys(_Form).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Form[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Form[key];
      }
    });
  });
  Object.keys(_Message).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Message[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Message[key];
      }
    });
  });
  Object.keys(_Contract).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Contract[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Contract[key];
      }
    });
  });
  Object.keys(_Files).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Files[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Files[key];
      }
    });
  });
  Object.keys(_Profile).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Profile[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Profile[key];
      }
    });
  });
  Object.keys(_Building).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Building[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Building[key];
      }
    });
  });
  Object.keys(_InvoicePaid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _InvoicePaid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _InvoicePaid[key];
      }
    });
  });
  Object.keys(_EditSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _EditSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _EditSolid[key];
      }
    });
  });
  Object.keys(_Archive).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Archive[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Archive[key];
      }
    });
  });
  Object.keys(_Unarchive).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Unarchive[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Unarchive[key];
      }
    });
  });
  Object.keys(_Settings).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Settings[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Settings[key];
      }
    });
  });
  Object.keys(_Link).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Link[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Link[key];
      }
    });
  });
  Object.keys(_Close).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Close[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Close[key];
      }
    });
  });
  Object.keys(_Smile).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Smile[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Smile[key];
      }
    });
  });
  Object.keys(_Attachment).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Attachment[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Attachment[key];
      }
    });
  });
  Object.keys(_Share).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Share[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Share[key];
      }
    });
  });
  Object.keys(_Reply).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Reply[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Reply[key];
      }
    });
  });
  Object.keys(_Calendar).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Calendar[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Calendar[key];
      }
    });
  });
  Object.keys(_At).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _At[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _At[key];
      }
    });
  });
  Object.keys(_List).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _List[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _List[key];
      }
    });
  });
  Object.keys(_NumberedList).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _NumberedList[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _NumberedList[key];
      }
    });
  });
  Object.keys(_UnorderedList).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _UnorderedList[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _UnorderedList[key];
      }
    });
  });
  Object.keys(_Checklist).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Checklist[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Checklist[key];
      }
    });
  });
  Object.keys(_Tasks).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Tasks[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Tasks[key];
      }
    });
  });
  Object.keys(_Filter).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Filter[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Filter[key];
      }
    });
  });
  Object.keys(_Templates).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Templates[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Templates[key];
      }
    });
  });
  Object.keys(_Star).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Star[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Star[key];
      }
    });
  });
  Object.keys(_Email).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Email[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Email[key];
      }
    });
  });
  Object.keys(_EmailUnread).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _EmailUnread[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _EmailUnread[key];
      }
    });
  });
  Object.keys(_EmailRead).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _EmailRead[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _EmailRead[key];
      }
    });
  });
  Object.keys(_Authentication).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Authentication[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Authentication[key];
      }
    });
  });
  Object.keys(_Unlock).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Unlock[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Unlock[key];
      }
    });
  });
  Object.keys(_H).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _H[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _H[key];
      }
    });
  });
  Object.keys(_H2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _H2[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _H2[key];
      }
    });
  });
  Object.keys(_H3).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _H3[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _H3[key];
      }
    });
  });
  Object.keys(_Text).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Text[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Text[key];
      }
    });
  });
  Object.keys(_Bold).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Bold[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Bold[key];
      }
    });
  });
  Object.keys(_Italicize).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Italicize[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Italicize[key];
      }
    });
  });
  Object.keys(_Underline).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Underline[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Underline[key];
      }
    });
  });
  Object.keys(_Strikethrough).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Strikethrough[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Strikethrough[key];
      }
    });
  });
  Object.keys(_Menu).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Menu[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Menu[key];
      }
    });
  });
  Object.keys(_Inbox).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Inbox[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Inbox[key];
      }
    });
  });
  Object.keys(_Home).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Home[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Home[key];
      }
    });
  });
  Object.keys(_Notification).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Notification[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Notification[key];
      }
    });
  });
  Object.keys(_Billing).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Billing[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Billing[key];
      }
    });
  });
  Object.keys(_Dollar).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Dollar[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Dollar[key];
      }
    });
  });
  Object.keys(_Helpdesk).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Helpdesk[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Helpdesk[key];
      }
    });
  });
  Object.keys(_AppSetup).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _AppSetup[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _AppSetup[key];
      }
    });
  });
  Object.keys(_Gift).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Gift[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Gift[key];
      }
    });
  });
  Object.keys(_Location).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Location[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Location[key];
      }
    });
  });
  Object.keys(_Number).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Number[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Number[key];
      }
    });
  });
  Object.keys(_MobileNumber).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MobileNumber[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MobileNumber[key];
      }
    });
  });
  Object.keys(_Airtable).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Airtable[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Airtable[key];
      }
    });
  });
  Object.keys(_QuickBook).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _QuickBook[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _QuickBook[key];
      }
    });
  });
  Object.keys(_Bank).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Bank[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Bank[key];
      }
    });
  });
  Object.keys(_Puzzle).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Puzzle[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Puzzle[key];
      }
    });
  });
  Object.keys(_Code).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Code[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Code[key];
      }
    });
  });
  Object.keys(_ArrowUpSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ArrowUpSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ArrowUpSolid[key];
      }
    });
  });
  Object.keys(_ArrowDownSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ArrowDownSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ArrowDownSolid[key];
      }
    });
  });
  Object.keys(_ArrowLeft).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ArrowLeft[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ArrowLeft[key];
      }
    });
  });
  Object.keys(_ArrowRight).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ArrowRight[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ArrowRight[key];
      }
    });
  });
  Object.keys(_ArrowNE).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ArrowNE[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ArrowNE[key];
      }
    });
  });
  Object.keys(_Dash).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Dash[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Dash[key];
      }
    });
  });
  Object.keys(_Compose).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Compose[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Compose[key];
      }
    });
  });
  Object.keys(_MassFileShare).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MassFileShare[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MassFileShare[key];
      }
    });
  });
  Object.keys(_Warning).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Warning[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Warning[key];
      }
    });
  });
  Object.keys(_WarningSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _WarningSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _WarningSolid[key];
      }
    });
  });
  Object.keys(_Failed).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Failed[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Failed[key];
      }
    });
  });
  Object.keys(_FailedSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _FailedSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _FailedSolid[key];
      }
    });
  });
  Object.keys(_Check).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Check[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Check[key];
      }
    });
  });
  Object.keys(_Success).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Success[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Success[key];
      }
    });
  });
  Object.keys(_SuccessSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _SuccessSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _SuccessSolid[key];
      }
    });
  });
  Object.keys(_New).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _New[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _New[key];
      }
    });
  });
  Object.keys(_ToDo).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ToDo[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ToDo[key];
      }
    });
  });
  Object.keys(_InProgress).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _InProgress[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _InProgress[key];
      }
    });
  });
  Object.keys(_Book).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Book[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Book[key];
      }
    });
  });
  Object.keys(_Send).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Send[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Send[key];
      }
    });
  });
  Object.keys(_Dot).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Dot[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Dot[key];
      }
    });
  });
  Object.keys(_SquareSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _SquareSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _SquareSolid[key];
      }
    });
  });
  Object.keys(_Eye).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Eye[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Eye[key];
      }
    });
  });
  Object.keys(_EyeHidden).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _EyeHidden[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _EyeHidden[key];
      }
    });
  });
  Object.keys(_Invoice).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Invoice[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Invoice[key];
      }
    });
  });
  Object.keys(_Comment).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Comment[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Comment[key];
      }
    });
  });
  Object.keys(_Invite).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Invite[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Invite[key];
      }
    });
  });
  Object.keys(_Spinner).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Spinner[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Spinner[key];
      }
    });
  });
  Object.keys(_Repeat).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Repeat[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Repeat[key];
      }
    });
  });
  Object.keys(_Web).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Web[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Web[key];
      }
    });
  });
  Object.keys(_Time).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Time[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Time[key];
      }
    });
  });
  Object.keys(_GraphBarSolid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _GraphBarSolid[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _GraphBarSolid[key];
      }
    });
  });
  Object.keys(_Sidebar).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Sidebar[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Sidebar[key];
      }
    });
  });
  Object.keys(_SidebarFilled).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _SidebarFilled[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _SidebarFilled[key];
      }
    });
  });
  Object.keys(_Export).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Export[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Export[key];
      }
    });
  });
  Object.keys(_File).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _File[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _File[key];
      }
    });
  });
  Object.keys(_MP).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MP[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MP[key];
      }
    });
  });
  Object.keys(_SVG).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _SVG[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _SVG[key];
      }
    });
  });
  Object.keys(_MOV).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MOV[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MOV[key];
      }
    });
  });
  Object.keys(_MP2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _MP2[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _MP2[key];
      }
    });
  });
  Object.keys(_CSV).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _CSV[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _CSV[key];
      }
    });
  });
  Object.keys(_Excel).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Excel[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Excel[key];
      }
    });
  });
  Object.keys(_PNG).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _PNG[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _PNG[key];
      }
    });
  });
  Object.keys(_PDF).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _PDF[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _PDF[key];
      }
    });
  });
  Object.keys(_JPG).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _JPG[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _JPG[key];
      }
    });
  });
  Object.keys(_Doc).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Doc[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Doc[key];
      }
    });
  });
  Object.keys(_ZIP).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _ZIP[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ZIP[key];
      }
    });
  });
  Object.keys(_Movie).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Movie[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Movie[key];
      }
    });
  });
  Object.keys(_GIF).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _GIF[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _GIF[key];
      }
    });
  });
});
